// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ede2043f","238":"1bb2cdd1","239":"bec4408c","455":"03aafff1","488":"71446e00"}[chunkId] + ".chunk.js";
};